import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import Loader from "../../UI/loader";
import SpaBooking3a from "./spaBooking3a";
import SpaBooking3b from "./spaBooking3b";
import SpaBooking3summary from "./spaBooking3summary";
import SpaBooking3c from "./spaBooking3c";
import { searchSpaAvailability , makeSpaBooking } from "../../../action/spaBooking";
import moment from "moment";


const sample_resp={
    "header": {
        "status": {
            "code": "SUCCESS",
            "msg": "Search Availability Suceess."
        }
    },
    "payload": {
        "data": [
            {
                "spaLocationId": 51122,
                "serviceId": 321,
                "basePrice" : 99.0, // This is the base price of the service
                "availabilityData": [
                    {
                        "startTime": 540,
                        "availableDate": "2024-03-05T09:30:00-05:00",
                        "results": [
                            {
                                "technicianId": 12345,
                                "technicianName": "John Doe",
                                "startTime": 540,
                                "price": 150.00,
                                "duration": 60
                            },
                            {
                                "technicianId": 67890,
                                "technicianName": "Jane Smith",
                                "startTime": 540,
                                "price": 200.00,
                                "duration": 60
                            }
                        ]
                    },
                    {
                        "startTime": 600,
                        "availableDate": "2024-03-05T10:00:00-05:00",
                        "results": [
                            {
                                "technicianId": 12345,
                                "technicianName": "John Doe",
                                "startTime": 600,
                                "price": 150.00,
                                "duration": 60
                            }
                        ]
                    }
                ]
            }
        ]
    }
};


const fakeResReservation=
{
     "header": {
     "status": {
     "code": "SUCCESS",
     "msg": "Appointment saved successfully."
     }
     },
     "payload": {
     "data": {
     "errorCode": 0, // Error code (0 if no important error)
     "errorDetail": "sample string 1", // Guest Friendly error message in case of failure (if )
     "appointmentId": 2 // ID of the new appointment (if saved successfully)

}
 }
}





export const formatDateAsDateFormat=(date,format)=>{

    console.log("props.dateFormat",format)

  if(format && format!='')
    {
      return moment(new Date(date)).format(format)
    }
    else{
      return moment(new Date(date)).format('MMMM Do, h:mm a')
    }

  }

const SpaBooking3 = (props) => {

    const { t } = props
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
    let widgetSesstionId = localStorage.getItem("spaBookingSessionToken");

    const [loading, setLoading] = useState(false);
    const [displayLoadingMsg, setDisplayLoadingMsg] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [serviceDetails, setServiceDetails] = useState({
        "dateTime": "",
        "technicianId": "",
        "guestNotes": "",
    });

    const [technicianAvailableData, setTechnicianAvailableData] = useState([]);
    const [selectedTechnicianDetails, setSelectedTechnicianDetails]=useState(null);


  

    const handleSelectServiceDetailsNext = (selectedServiceDetails) => {
        setServiceDetails({...serviceDetails, selectedServiceDetails})

        let searchAvailabilityPayload = {
            "dateTime": selectedServiceDetails.dateTime,
            "serviceId": [+selectedServiceId],
            "spaLocationId": props.spaLocationId ,
            "requestedType": selectedServiceDetails.requestedType
        }
        console.log('payload of availabily post api', searchAvailabilityPayload)

        setLoading(true); setDisplayLoadingMsg("Fetching availability...")
        console.log(searchAvailabilityPayload,'searchAvailabilityPayload')
        // const res= sample_resp
        // console.log(res.payload.data[0].availabilityData,'res.payload.data[0].availabilityData')
        // setTechnicianAvailableData(res.payload.data[0].availabilityData)

        //         setCurrentPage(3)
        //         setLoading(false);
                

        searchSpaAvailability(searchAvailabilityPayload)
        .then((res) => {


            setLoading(false);

            if(res.status != 200){


                props.closeOrderPopUp(true, res.response.data.header.status.msg , "", true)

                props.sendAnalytics(
                    props.guestDetail,
                    props.currentWidgets.widgetType,
                    "FETCH SPA TECHNICIAN - ERROR",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg) },
                    0,
                    props.guestIsLoggedIn
                );
            } else {
                // res= sample_resp;
                setTechnicianAvailableData(res.data.payload.data.reduce((acc,curr)=>{curr.availabilityData.forEach(d=>{acc.push(d)}); return acc;},[] ))
                setCurrentPage(3)
                

                props.sendAnalytics(
                    props.guestDetail,
                    props.currentWidgets.widgetType,
                    "FETCH SPA TECHNICIAN - SUCCESS",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                    0,
                    props.guestIsLoggedIn
                );
            }

        })
        .catch((err) => { 
            setLoading(false); 
            props.closeOrderPopUp(true, t('spaBooking.errors.error'), "", true)
        })
    }

    const handleMakeReservation= async (payload)=>{

        console.log('payload of makeresevation api', payload)
        const {data}= await makeSpaBooking(payload)
        // props.handleReservationSuccess(fakeResReservation)


        setLoading(true); setDisplayLoadingMsg("Making your reservation...")
        
        
        makeSpaBooking(payload)
        .then((res) => {


            setLoading(false);

            if(res.status != 200 || res.data.header.status.code!='SUCCESS' ){


                props.closeOrderPopUp(true, res.data.header.status.msg , "", true)

                props.sendAnalytics(
                    props.guestDetail,
                    props.currentWidgets.widgetType,
                    "Make SPA RESERVATION - ERROR",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg) },
                    0,
                    props.guestIsLoggedIn
                );
            } else {
     
                props.handleReservationSuccess(res.data)
                

                props.sendAnalytics(
                    props.guestDetail,
                    props.currentWidgets.widgetType,
                    "Make SPA RESERVATION - SUCCESS",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                    0,
                    props.guestIsLoggedIn
                );
            }

        })
        .catch((err) => { 
            setLoading(false); 
            props.closeOrderPopUp(true, t('spaBooking.errors.error'), "", true)
        })

    }

    const handleSelectServiceNext = (serviceId) => {
        setSelectedServiceId(serviceId);
        setCurrentPage(2);
    }

    const handleGoBack = () => {

        if (currentPage == 4) {
            setCurrentPage(3)
            return;
        }

        if (currentPage == 3) {
            setSelectedTechnicianDetails(null)
            console.log("happening 3")
            setCurrentPage(2)
            return;
        }

        if (currentPage == 2) {
            setServiceDetails({
                "dateTime": "",
                "technicianId": "",
                "guestNotes": "",
            })
            setTechnicianAvailableData([])
            setCurrentPage(1)
            return;
        }

        props.goBack()
    }
    const handleNextToSummaryPage=(details)=>{
        console.log(details, 'spabookng details')
        setCurrentPage(4);      
    }

    useEffect(() => {
        if (!loading) setDisplayLoadingMsg("");
    }, [loading])

    useEffect(() => {

        console.log("inside grouped - sb3", props)
        if (!props.spaLocationId || props.serviceData.services.length == 0) {
            props.closeOrderPopUp(true, t('spaBooking.errors.no_data_found'), "", true)
            props.goBack();

            return;
        }

    }, [])

    useEffect(()=>{console.log(serviceDetails,'setServiceDetails in sb3')})

    

    return (
        <>
            {currentPage == 1 && <SpaBooking3a serviceData={props.serviceData} selectedServiceId={selectedServiceId} next={(serviceId) => handleSelectServiceNext(serviceId)} goBack={() => handleGoBack()} />}
            {currentPage == 2 && <SpaBooking3b serviceData={props.serviceData} selectedServiceId={selectedServiceId} serviceDetails={serviceDetails} next={(serviceDetails) => handleSelectServiceDetailsNext(serviceDetails)} goBack={() => handleGoBack()} />}
            {currentPage == 3 && <SpaBooking3c serviceData={props.serviceData} selectedServiceId={selectedServiceId} serviceDetails={serviceDetails} technicianAvailableData={technicianAvailableData} handleNextToSummaryPage={handleNextToSummaryPage} selectedTechnicianDetails={selectedTechnicianDetails} setSelectedTechnicianDetails={setSelectedTechnicianDetails} goBack={()=>{handleGoBack()}}/>}
            {currentPage == 4 && <SpaBooking3summary serviceData={props.serviceData} selectedServiceId={selectedServiceId}  technicianAvailableData={technicianAvailableData} selectedTechnicianDetails={selectedTechnicianDetails}  spaLocationId={props.spaLocationId} handleMakeReservation={handleMakeReservation} handleBack={()=>handleGoBack()} />}
            {loading && <Loader displayMsg={displayLoadingMsg} />}
        </>
    )

}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
    }
}

export default connect(mapStateToProps, { closeOrderPopUp, sendAnalytics })(withTranslation('translations')(SpaBooking3));